// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__1-Mt4","paragraph":"footer_paragraph__2hqzV","link":"footer_link__vy5_m","social_link":"footer_social_link__3RbIk"};